<template>
    <div class="Details">
        <div class="container">
            <h2>{{title}}</h2>
            <div class="row">
                <div class="col-md-12" v-for="(bot,index) in bots" :key="index">
                    <div v-if="proId == bot.botId">
                        <h1>{{bot.botName}}</h1>
                        <img :src="bot.image" class="img-fluid">
                    </div>
                </div>
            </div>
            <span v-bind:title="message">
                Наведи на меня курсор на пару секунд,
                чтобы увидеть динамически связанное значение title!
            </span>
            <br/>
            <span v-if="seen">Сейчас меня видно</span>
        </div>
    </div>
</template>

<script>
export default {

    name: 'Details',
    data() {
        return {
            proId: this.$route.params.Pid,
            title: 'Details',
            bots: [
            ],
            message: 'Вы загрузили эту страницу: ' + new Date().toLocaleString(),
            seen: false
        }
    }
}
</script>

<style scoped>

</style>
